module.exports = __webpack_public_path__ + "images/juizz_small11856b57ad3e8ca98082ef734ebec0bb.png";